<div class='Home_introduce container pt-5'>
  <div class='Home_introduce_wrapper d-flex flex-column'>
    <div class='flex-grow-1'>
      <h2 class='text-center'>
        <span> Let Retreva Introduce you to your Next Customer</span>
      </h2>
    </div>
    <div class='flex-grow-1'>
      <ul class='d-flex flex-column flex-sm-row pt-5'>
        <li class='HomeFeatures-item text-center'>
          <label><img alt='' src='assets/images/retail/s1.png' /></label>
          <h3>Find the right contacts</h3>
          <p>
            Upload a spreadsheet or add a single contact on the fly anytime. We
            will even notify you when you need to add more.
          </p>
        </li>
        <li class='HomeFeatures-item text-center'>
          <label><img alt='' src='assets/images/retail/s2.png' /></label>
          <h3>Write effective content</h3>
          <p>
            Retreva's content writers understand the psychology behind
            prospecting. We will write the perfect content that will be sure to
            get positive replies.
          </p>
        </li>
        <li class='HomeFeatures-item text-center'>
          <label><img alt='' src='assets/images/retail/s3.png' /></label>
          <h3>Manage responses</h3>
          <p>
            Login to your Retreva inbox to select the appropriate responses.
            With one click, a reply is created and the contact is updated.
          </p>
        </li>
        <li class='HomeFeatures-item text-center'>
          <label><img alt='' src='assets/images/retail/s4.png' /></label>
          <h3>Prospect &amp; set meetings</h3>
          <p>
            Let Retreva set meetings while you focus on closing sales.
            Retreva also automatically creates and schedules all follow up
            emails.
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>
